import { useRef } from "react"

const LogoutButton = ({ txt = "Un bouton standard", css = "", img = null, btnFunction = alert("Une alerte") }) => {

    const btnRef = useRef()
    const cssBtn = img ? `${css} bg-white px-3 py-2 flex flex-col gap-2 justify-center items-center border-2 border-darkRed rounded-lg` : `flexJustifyItemsCenter btn btn-inactive ${css}`

    const handleMouseOver = () => {
        btnRef.current.className = "flexJustifyItemsCenter btn btn-active"
    }
    const handleMouseOut = () => {
        btnRef.current.className = "flexJustifyItemsCenter btn btn-inactive"
    }
    const handleClick = (e) => {
        e.preventDefault()
        btnFunction()
    }

    return (
        <button ref={btnRef} className={cssBtn} onClick={handleClick} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            {img && img}
            <span>{txt}</span>
        </button>
    )
}

export default LogoutButton